import PropTypes from 'prop-types';
import React from 'react';
import { Controller } from 'react-hook-form';

import MaskInput from 'components/atomic/controls/MaskInput';

const MaskField = ({ name, control, rules = {}, feedback, ...restProps }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        // eslint-disable-next-line no-unused-vars
        field: { ref, ...restField },
        fieldState: { error },
        formState: { isSubmitted },
      }) => <MaskInput {...restProps} {...restField} valid={isSubmitted && !error} invalid={isSubmitted && error} feedback={error?.message || feedback} />}
    />
  );
};

MaskField.propTypes = {
  name: PropTypes.string,
  control: PropTypes.object,
  rules: PropTypes.object,
  feedback: PropTypes.node,
};

export default MaskField;
